import { render, staticRenderFns } from "./ComissaoBusca.vue?vue&type=template&id=69834d08"
import script from "./ComissaoBusca.vue?vue&type=script&lang=js"
export * from "./ComissaoBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports